// extracted by mini-css-extract-plugin
module.exports = {"content-modal":"modal_content-modal__2Rd9Q","container-gif":"modal_container-gif__HX3kq"};